module.exports = __webpack_public_path__ + "static/media/playarrow.823f7ce6.png";